import { Link } from "react-router-dom";
import { useState } from "react";
import "./Sidebar.css";
import { FaStickyNote, FaFileInvoiceDollar, FaListAlt, FaTachometerAlt, FaClipboardList, FaIdCard, FaUsers, FaTags, FaLayerGroup, FaFileInvoice, FaMoneyBill, FaFileAlt, FaExchangeAlt, FaCog, FaUserTie, FaBook, FaChartPie } from "react-icons/fa";

const Sidebar = () => {
  const [accountingOpen, setAccountingOpen] = useState(false);

  return (
    <div
      className="sidebar-wrapper bg-dark text-light vh-100 d-flex flex-column"
      style={{ width: "200px", position: "fixed" }}
    >
      <h4 className="text-center">Sentry</h4>
      <div
        className="flex-grow-1 p-2"
        style={{
          overflowY: "scroll",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <ul className="nav flex-column">
          <li className="nav-item">
            <Link to="/dashboard" className="nav-link text-light">
              <FaTachometerAlt className="me-2" /> Dashboard
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/attendance-management" className="nav-link text-light">
              <FaClipboardList className="me-2" /> Attendance
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/swipe-card" className="nav-link text-light">
              <FaIdCard className="me-2" /> Swipe Card
            </Link>
          </li>

          {/* Collapsible Accounting Section */}
          <li className="nav-item">
            <button
              className="nav-link text-light bg-transparent border-0 w-100 text-start"
              onClick={() => setAccountingOpen(!accountingOpen)}
            >
              <FaChartPie className="me-2" /> Accounting
            </button>
          </li>
          {accountingOpen && (
            <ul className="nav flex-column ps-3">
              <li className="nav-item">
                <Link to="/receipt" className="nav-link text-light">
                  <FaFileInvoice className="me-2" /> Receipt
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/payment" className="nav-link text-light">
                  <FaMoneyBill className="me-2" /> Payment
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/journal" className="nav-link text-light">
                  <FaFileAlt className="me-2" /> Journal
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contra" className="nav-link text-light">
                  <FaExchangeAlt className="me-2" /> Contra
                </Link>
              </li>
            </ul>
          )}

          <li className="nav-item">
            <Link to="/account-statement" className="nav-link text-light">
              <FaFileInvoiceDollar className="me-2" /> Acc. Statement
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/fee-summary" className="nav-link text-light">
              <FaFileInvoiceDollar className="me-2" /> Fees Summary
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/acc-type-summary" className="nav-link text-light">
              <FaListAlt className="me-2" /> Acc. Type Summary
            </Link>
          </li>

          <hr className="text-light my-2" /> {/* Separator */}

          <li className="nav-item">
            <Link to="/student-list" className="nav-link text-light">
              <FaUsers className="me-2" /> Students
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/tests" className="nav-link text-light">
              <FaClipboardList className="me-2" /> Tests
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/term-exams" className="nav-link text-light">
              <FaFileAlt className="me-2" /> Exams
            </Link>
          </li>


          <li className="nav-item">
            <Link to="/staff-management" className="nav-link text-light">
              <FaUserTie className="me-2" /> Staff
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/label-management" className="nav-link text-light">
              <FaTags className="me-2" /> Labels
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/batch-management" className="nav-link text-light">
              <FaLayerGroup className="me-2" /> Batches
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/account-management" className="nav-link text-light">
              <FaFileInvoice className="me-2" /> Accounts
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/manage-subjects" className="nav-link text-light">
              <FaBook className="me-2" /> Subjects
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/settings" className="nav-link text-light">
              <FaCog className="me-2" /> Settings
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
